import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl30 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".grey{fill:#646973;}.red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_30",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "black",
				d: "M29.66,23.19l24.41-13.95c-.88-.76-2.01-1.24-3.26-1.24h-17.82c-2.76,0-5,2.24-5,5v6.49c0,1.47.65,2.78,1.66,3.7ZM30,13c0-1.65,1.35-3,3-3h16.37l-3.5,2h-.72v.41l-.7.4v-.81h-6.27v1.84h3.53l-.79.99-5.89,3.37h-.99v-6.2h-2.08v7.95l-1.6.91c-.22-.42-.35-.88-.35-1.38v-6.49ZM55.31,10.84c.32.66.51,1.39.51,2.16v6.49c0,2.76-2.24,5-5,5h-17.82c-.44,0-.86-.07-1.26-.18l3.18-1.82h15.9c1.65,0,3-1.35,3-3v-6.49c0-.42-.1-.8-.26-1.17l1.75-1ZM39.17,20.06l3.21-1.83h2.08v1.83h-5.29ZM49.63,14.38c0,.3-.11.4-.19.45h0c-.17.1-.4.15-.68.15h-.7l-2.91,1.66v3.42h3.67c.4,0,.78-.04,1.12-.11.36-.08.69-.22.96-.42.24-.18.44-.4.6-.66.25-.39.38-.84.38-1.34s-.11-.9-.33-1.24c-.15-.23-.34-.41-.57-.56.1-.08.18-.16.25-.24.27-.32.41-.75.41-1.27,0-.42-.11-.78-.3-1.1l-1.76,1.01c.03.07.05.15.05.27ZM49.79,17.42c0,.49-.21.64-.36.72-.15.07-.37.11-.67.11h-1.61v-1.52h1.63c.29,0,.51.04.66.11.23.11.34.29.34.58Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Signal",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M49,55.83h-12c-1.1,0-2-.9-2-2v-20c0-.53.21-1.04.59-1.41l2.83-2.83c.38-.38.88-.59,1.41-.59h6.34c.53,0,1.04.21,1.41.59l2.83,2.83c.38.38.59.88.59,1.41v20c0,1.1-.9,2-2,2Z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "grey",
						cx: 43,
						cy: 38.83,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "grey",
						cx: 40,
						cy: 44.83,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "grey",
						cx: 46,
						cy: 44.83,
						r: 2
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Train",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M27.21,46.75c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M29.79,34.04c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM26.37,48.4c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M25.21,34.02c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM21.94,38.54c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M13.66,46.81c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M23.22,46.81c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl30;
